<ng-template #labelTemplate>
  <mp-filter-group-label [label]="label()" [value]="selectedValue()" [singleSelect]="singleSelect()" />
</ng-template>

<mp-vertical-tab-group class="group" [isSelected]="isSelected()">
  <ng-content />
</mp-vertical-tab-group>
